import './scripts/common';
import { onFind } from '@elements/init-modules-in-scope';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as anchorNav from '@elements/anchor-nav/bootstrap-5';
anchorNav.init({
    renderItem:function(text, anchor){
        return '<li class="nav-item"><a class="js-smoothscroll__link nav-link" data-scroll-offset="0" href="#' + anchor + '"><span class="anchor-nav__title">' + text + '</span></a></li>';
    },
    smoothScroll:true,
    scrollSpy:true,
    scrollSpyTarget:'.js-anchor-nav',
    scrollSpyOffset:0

}, {
    list:'.js-anchor-nav__list',
    item:'.js-anchor-nav__item'
});

/*import * as smoothScroll from './scripts/smooth-scroll';
smoothScroll.init();*/


import * as imageGrid from './scripts/image-grid';
imageGrid.init();

import * as numberSpinner from './scripts/number-spinner';
numberSpinner.init();

import * as showAll from './scripts/show-all';
showAll.init()

import Dropdown from 'bootstrap/js/dist/dropdown';
onFind('.js-dropdown', function(element){
    new Dropdown(element);
});

import * as downloadModal from './scripts/download-modal';
downloadModal.init();